<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('type')">
            <app-default-button
                :title="$fieldTitle('add', 'type', true)"
                v-if="$can('create_document_type')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="document-type-table"
            :options="options"
            @action="triggerActions"
        />

        <app-document-type-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('document-type-table')"
            @cancelled="cancelled"
        />
    </div>
</template>
<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import DocumentTypeMixins from "../../../Mixins/DocumentTypeMixins";
import {DOCUMENT_TYPE} from "../../../../Config/ApiUrl";

export default {
    name  : "AppDocumentType",
    mixins: [HelperMixin, DocumentTypeMixins],
    data() {
        return {
            isModalActive: false,
            selectedUrl  : '',
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl   = `${DOCUMENT_TYPE}/${row.id}`;
                this.isModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },

        openModal() {
            this.isModalActive = true;
            this.selectedUrl   = ''
        },
    },
}
</script>
